var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag17Tr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E30A17;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy_1_",
    className: "st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 26.3,
    cy: 21,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.7,
    cy: 21,
    r: 9.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "43.3,23.9 40.2,22.7 38.1,25.4 38.3,22 35.1,20.8 38.4,19.9 38.5,16.6 40.4,19.4 43.6,18.5 41.5,21.1  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag17Tr);
export default __webpack_public_path__ + "static/media/flag_17_TR.5ba77a9b2bf292dc7004b5bbf98164b7.svg";
export { ForwardRef as ReactComponent };